import styled from 'styled-components';

import { ModalBody, Input, Button } from 'reactstrap';
import { color } from '../../../assets/styles/colors';

export const Title = styled.h5`
	background-color: #D3FBE1;
	font-size: 18px;
	font-weight: bold;
	padding: 11px 0 11px 4vw;
	overflow: auto;
	border-bottom: 1px solid black;
`;

export const Line = styled.div`
	margin: 10px 0px 0px 0px;
	border-bottom: 1px solid black;
	width: 100%;
`;

export const ModalBodyCss = styled(ModalBody)`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 2vh 4vw 6vh 4vw;
`;

export const ModalFooterCss = styled.div`
	background-color: #D3FBE1;
	border-top: 1px solid black;
	text-align: right;
	width: 100%;
	height: 7.5vh;
	padding: 0px 5vw 50px 0;

	@media (max-width: 768px) {
		padding: 0px 0px 50px 0;
		text-align: center;
	}
`;

export const ButtonCss = styled(Button)`
	font-size: 14px;
	min-height: 32px;
	font-weight: 500;
	margin: 18px;
	background-color: ${color.yellow};
`;

export const InputCss = styled(Input)`
	min-height: 200px;
`;

export const TextError = styled.div`
	color: ${color.red};
`;
